var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":"blank"}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('_title')))]),_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.$t('subtitle')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }